<template>
  <div class="t9_serach wrapper">
    <div v-if="step == 1" style="padding: 0 0.3rem;">
      <div class="title-layer" v-if="v1.length > 0">您的总价预算是？</div>
      <div class="block-content">
        <div class="block-item" v-for="item in v1" :class="{active: item.check == true}" @click="selItem(item, 1)">{{item.tagname}}</div>
      </div>

      <div class="title-layer" v-if="v3.length > 0">您要买的区域？</div>
      <div class="select-layer">
        <div class="select">
          <select
            class="common-select"
            v-model="cid"
            @change="cityChange"
          >
            <option value="" disabled selected></option>
            <!-- <option value="" selected>不限</option> -->
            <option :value="item.id" v-for="(item, index) in v3">{{item.tagname}}&#x200E;</option>
          </select>
        </div> 
      </div>  

      <div class="block-content" v-if="v4.length > 0" style="margin-top: .1rem;">
        <div class="block-item" v-for="item in v4" :class="{active: item.check == true}" @click="selItem(item, 4)">{{item.tagname}}</div>
      </div>      

      <div class="title-layer" v-if="v2.length > 0">您要买什么户型的房子？</div>
      <div class="block-content">
        <div class="block-item" v-for="item in v2" :class="{active: item.check == true}" @click="selItem(item, 2)">{{item.tagname}}</div>
      </div>

      <div class="title-layer" v-if="v5.length > 0">您的购房目的？</div>
      <div class="block-content">
        <div class="block-item" v-for="item in v5" :class="{active: item.check == true}" @click="selItem(item, 5)">{{item.tagname}}</div>
      </div>

      <div class="title-layer" v-if="v6.length > 0">您要买多大面积的？</div>
      <div class="block-content">
        <div class="block-item" v-for="item in v6" :class="{active: item.check == true}" @click="selItem(item, 6)">{{item.tagname}}</div>
      </div>

      <div class="title-layer" v-if="v7.length > 0">您还有其他要求吗？</div>
      <div class="block-content">
        <div class="block-item" v-for="item in v7" :class="{active: item.check == true}" @click="selItem(item, 7)">{{item.tagname}}</div>
      </div>

      <div class="btn" @click="submitForm">提交找房需求</div> 
    </div>

    <div v-if="step == 2">
      <div class="header-layer">
        <div class="top-layer">
          <div class="txt">您的找房需求</div>
          <div class="btn2" @click="goEdit">编辑</div>
        </div>
        <div class="txt-layer">{{findtxt}}</div>
      </div>
      <div class="content" ref="contentLayer">
        <!--发布list-->
        <div class="data-item" v-if="list.length > 0">为您找到了以下房源</div>
        <div class="common-nodata-log" v-if="noData"></div>
        <div class="common-nodata-item" v-if="noData">暂无符合您的定制楼盘</div>
        <div class="data-item" v-if="list2.length > 0">为您推荐以下房源</div>
        <mt-loadmore :bottom-method="loadMore" :bottom-all-loaded="!hasMore" ref="loadmore">
          <projectList :list="list"></projectList>
          <projectList :list="list2" v-if="list2.length > 0"></projectList>
        </mt-loadmore>
        <div class="common-nodata-item" v-if="allLoad">已加载全部数据</div>
      </div>      
    </div>

    <!-- lj52 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
import { Loadmore } from "mint-ui"; //上拉刷新
import Cookies from "js-cookie";
import Vue from "vue";
Vue.component(Loadmore.name, Loadmore);

const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
const projectList = () => import("@/components/project_list");

export default {
  components: {
    BtnBackLayout4,
    projectList
  },
  data() {
    return {
      step: "",
      //page1
      taglist: [],
      v1: [],
      v2: [],
      v3: [],
      v4: [],
      v5: [],
      v6: [],
      v7: [],
      cid: "",
      cacheData: [],

      //page2
      noData: false,
      allLoad: false,
      hasMore: true,
      loading: true,
      pageIndex: 1,
      offset: 0,
      pageSize: 20,
      contentH: 0,
      list: [],
      list2: [],

      findtxt: '',

      findids: [],
      citytagid: '',
      totalpricetag: [],
      housetypetag: [],
      districttag: [],
      citytag: [],
      purposetag: [],
      areatag: [],
      othertag: [],
      areaslist: [],
      cityname: "",

      priceTagIds: [],
      houseTypeTagIds: [],
      cityTagIds: [],
      districtTagIds: [],
      purposeTagIds: [],
      areaTagIds: [],
      otherTagIds: [],

    };
  },
  computed: {
    ...mapState(["userInfo", "pageInfo"])
  },
  watch: {},
  filters: {},
  methods: {
    selItem(item, type) {
      let that = this
      let tmp = []
      this['v'+type].forEach(e => {
        if(e.id == item.id) {
          e.check = !e.check
        } else if (type == 4) {
          //区域单选
          e.check = false
        }
        tmp.push(e)
      })
      this['v'+type] = tmp
    },
    cityChange(type) {
      let that = this
      that.v4 = []
      if(that.cid) {
        //选择了城市
        if(type != 'edit') {
          let tmp = []
          that.v3.forEach(e => {
            if(e.id == that.cid) {
              e.check = true
            } else {
              e.check = false
            }
            tmp.push(e)
          })
          that.v3 = tmp
        }
        that.taglist.forEach(e => {
          if(e.type == 4 && e.citytagid == that.cid) {
            that.v4.push({
              id: e.id,
              check: that.checkIsInCache(e.id),
              type: e.type,
              tagname: e.tagname                
            })            
          }
        })
      } else {
        if(type != 'edit') {
          let tmp = []
          that.v3.forEach(e => {
            e.check = false
            tmp.push(e)
          })
          that.v3 = tmp
          that.citytagid = ""
        }        
      }
    },
    submitForm() {
      let that = this
      let types = [1,2,3,4,5,6,7]
      let value = []
      types.forEach(idx => {
        that['v'+idx].forEach(e => {
          if(idx == 3 && that.cid && e.id == that.cid) {
            console.log()
            value.push(e)
          } else if(e.check) {
            value.push(e)
          }
        })
      })
      if(value.length <= 0) {
        return MessageBox.alert("请至少选择一个找房需求")
      }
      console.log(value,that.cid)
      let cacheKey = `t9_page_search_tag`
      util.setTimeStorage(cacheKey, JSON.stringify(value), 1 );
      that.cacheData = value
      // util.openYqRsMakeLink(
      //   `${location.protocol}//${location.host}/h5/t9_result`
      // );
      that.initData2()
    },
    checkIsInCache(id) {
      let that = this
      let v = false 
      // console.log(id,that.cacheData)
      that.cacheData.forEach(e => {
        if(e.id == id) {
          v = true
          if(e.type == 3) {
            that.cid = e.id
            that.cityChange('edit')
          }
        }
      })
      return v
    },

    loadMore() {
      const that = this;
      if (that.hasMore && !that.loading) {
        that.pageIndex++;
        that.loadData();
      }
    },
    loadData(type) {
      let that = this;
      that.loading = true;
      let offset = that.pageIndex * that.pageSize - that.pageSize;
      let size = that.pageSize;
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        comreq
          .searchBuilding(
            that.priceTagIds.join(','),
            that.houseTypeTagIds.join(','),
            that.cityTagIds.join(','),
            that.districtTagIds.join(','),
            that.purposeTagIds.join(','),
            that.areaTagIds.join(','),
            that.otherTagIds.join(','),
            // that.findids,
            // that.citytagid,
            {
              openid: Cookies.get("openid"),
              totalpricetag: that.totalpricetag.join(','),
              housetypetag: that.housetypetag.join(','),
              districttag: that.districttag.join(','),
              citytag: that.citytag.join(','),
              purposetag: that.purposetag.join(','),
              areatag: that.areatag.join(','),
              othertag: that.othertag.join(','),
              userneed: '',
            },
            offset,
            size,
          )
          .then(data => {
            if (data.obj.total == 0) {
              if(data.obj.total2 > 0 && data.obj.list2 && data.obj.list2.length > 0) {
                that.noData = true;
                that.$refs.loadmore.onBottomLoaded();
                that.loading = false;
                let list2 = [];
                data.obj.list2.forEach(e => {
                  if (e.extinfo) {
                    e.extinfo = JSON.parse(e.extinfo);
                    if (e.extinfo.advantage) {
                      e.extinfo.advantage = e.extinfo.advantage.split(",");
                    }
                  }
                  this.areaslist.forEach(item => {
                    item.list.forEach(item2 => {
                      if(item2.minipid === e.miniproj && e.miniproj) {
                        e.click_url += `&t9id=${item2.pageid}&t9psn=${item2.psn}`
                      }
                    })
                  })
                  list2.push(e);
                });
                that.list2 = that.list2.concat(list2);                
                if (data.obj.total2 <= that.list2.length) {
                  that.hasMore = false;
                  that.allLoad = true;
                }
                if (that.pageIndex == 1) {
                  that.$nextTick(() => {
                    that.$refs.contentLayer.scrollTop = 0;
                  });
                }
              } else {              
                that.list = [];
                that.noData = true;
              }
            } else {
              that.$refs.loadmore.onBottomLoaded();
              that.noData = false;
              that.loading = false;
              let list = [];
              data.obj.list.forEach(e => {
                if (e.extinfo) {
                  e.extinfo = JSON.parse(e.extinfo);
                  if (e.extinfo.advantage) {
                    e.extinfo.advantage = e.extinfo.advantage.split(",");
                  }
                }
                this.areaslist.forEach(item => {
                  item.list.forEach(item2 => {
                    if(item2.minipid === e.miniproj && e.miniproj) {
                      e.click_url += `&t9id=${item2.pageid}&t9psn=${item2.psn}`
                    }
                  })
                })
                list.push(e);
              });
              that.list = that.list.concat(list);
              if (data.obj.total <= that.list.length) {
                that.hasMore = false;
                that.allLoad = true;
              }
              if (that.pageIndex == 1) {
                that.$nextTick(() => {
                  that.$refs.contentLayer.scrollTop = 0;
                });
              }
            }
            console.log("项目数据", data.obj);
          });
      });
    },

    goEdit() {
      let that = this
      that.step = 1
      that.initData()
      // util.openYqRsMakeLink(
      //   `${location.protocol}//${location.host}/h5/t9_search`
      // );
    },

    initData2() {
      let that = this;
      that.list = [];
      that.list2 = [];
      that.pageIndex = 1;
      that.offset = 0;
      that.pageSize = 20;
      that.hasMore = true;
      that.loading = true;
      that.noData = false;
      that.allLoad = false;
      that.totalpricetag = [];
      that.housetypetag = [];
      that.districttag = [];
      that.citytag = [];
      that.purposetag = [];
      that.areatag = [];
      that.othertag = [];

      that.priceTagIds = [];
      that.houseTypeTagIds = [];
      that.cityTagIds = [];
      that.districtTagIds = [];
      that.purposeTagIds = [];
      that.areaTagIds = [];
      that.otherTagIds = [];

      let t1 = [], t2 = [];

      if(that.cacheData && that.cacheData.length > 0) {
        that.cacheData.forEach(e => {
          t1.push(e.tagname)
          if(e.type != 3) {
            t2.push(e.id)
          }
          switch (e.type) {
            case 1:
              that.totalpricetag.push(e.tagname)
              that.priceTagIds.push(e.id)
              break;
            case 2:
              that.housetypetag.push(e.tagname)
              that.houseTypeTagIds.push(e.id)
              break;
            case 3:
              that.citytagid = e.id
              that.citytag.push(e.tagname)
              that.cityTagIds.push(e.id)
              break;
            case 4:
              that.districttag.push(e.tagname)
              that.districtTagIds.push(e.id)
              break;
            case 5:
              that.purposetag.push(e.tagname)
              that.purposeTagIds.push(e.id)
              break;
            case 6:
              that.areatag.push(e.tagname)
              that.areaTagIds.push(e.id)
              break;              
            case 7:
              that.othertag.push(e.tagname)
              that.otherTagIds.push(e.id)
              break;  
            default:
              break;
          }
        })
      }
      that.findtxt = t1.join('、')
      that.findids = t2

      if(that.priceTagIds.length <= 0 || that.cityTagIds.length <= 0) {
        return MessageBox.alert("总价预算和城市为必选项")
      }
      that.step = 2
      that.loadData();
    },

    initData() {
      let that = this 
      that.v1 = []
      that.v2 = []
      that.v3 = []
      that.v4 = []
      that.v5 = []
      that.v6 = []
      that.v7 = []
      that.cid = ""
      comreq.tagList().then(res => {
        if(res.code == 0 && res.obj && res.obj.total > 0) {
          that.taglist = res.obj.list
          res.obj.list.forEach(e => {
            switch (e.type) {
              case 1:
                that.v1.push({
                  id: e.id,
                  check: that.checkIsInCache(e.id),
                  type: e.type,
                  tagname: e.tagname                
                })
                break;
              case 2:
                that.v2.push({
                  id: e.id,
                  check: that.checkIsInCache(e.id),
                  type: e.type,
                  tagname: e.tagname                
                })
                break;
              case 3:
                if(!that.cid && that.cacheData.length <= 0 && e.tagname == that.cityname) {
                  that.cid = e.id
                  that.cityChange('edit')
                  that.v3.push({
                    id: e.id,
                    check: true,
                    type: e.type,
                    tagname: e.tagname                
                  })
                } else {                
                  that.v3.push({
                    id: e.id,
                    check: that.checkIsInCache(e.id),
                    type: e.type,
                    tagname: e.tagname                
                  })
                }
                break;
              case 5:
                that.v5.push({
                  id: e.id,
                  check: that.checkIsInCache(e.id),
                  type: e.type,
                  tagname: e.tagname                
                })
                break; 
              case 6:
                that.v6.push({
                  id: e.id,
                  check: that.checkIsInCache(e.id),
                  type: e.type,
                  tagname: e.tagname                
                })
                break;
              case 7:
                that.v7.push({
                  id: e.id,
                  check: that.checkIsInCache(e.id),
                  type: e.type,
                  tagname: e.tagname                
                })
                break;
              default:
                break;
            }
          })
          console.log(that.v1)
        } else {
          MessageBox.alert("未找到相关配置信息").then(() => {
            window.history.go(-1);
          })
        }
      })
    }

  },
  mounted() {
    let that = this 
    //获取当前城市
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      //获取配置的城市
      comreq.getSalerBuildingConfig().then(data => {
        let jsonObj = JSON.parse(data.obj);
        this.areaslist = jsonObj.areas;
        jsonObj.areas.forEach(item => {
          item.list.forEach(city => {
            if (city.url.indexOf(this.pageInfo.PageId) > -1) {
              this.cityname = city.name;
            }
          });
        });
        let cacheKey = `t9_page_search_tag`
        let cacheData = util.getTimeStorage(cacheKey)
        if(cacheData) {
          that.cacheData = JSON.parse(cacheData)
          // that.step = 2
          that.initData2()
        } else {
          that.step = 1
          that.initData()
        }
      });
    });
  }
};
</script>
<style lang="stylus" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;  
}
.title-layer {
  font-size: .32rem;
  font-weight: 600;
  color: #333333;
  line-height: .9rem
}
.block-content {
  display: flex;
  flex-wrap: wrap;
}
.block-content .block-item {
  height: 0.58rem;
  padding: 0 .24rem;
  background-color: #F8F8F8;
  text-align: center;
  line-height: 0.58rem;
  border-radius: 4px;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  color: #333333;
  font-size: 0.24rem;
}
.block-content .block-item.active {
  background-color: #E78F4E;
  color: #ffffff;
}

.wrapper .select-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/sysintro/dingwei.png') no-repeat 10px center;
  background-size: 16px 16px;
}

.wrapper .select-layer .select {
  flex: 1;
  height: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(153,153,153,1);
  position: relative;
}

.common-select {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  background: transparent;
  direction: ltr;
  color: #333333;
  padding-right: 24px;
  padding-left: 34px;
  background: url('https://assets.rurushishi.com/huafa-crm/icon_arrow2.png') no-repeat right 8px center;
  background-size: 12px 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.btn {
  height: .82rem;
  background: #E78F4E;
  border-radius: 5px;
  font-size: .26rem;
  color: #ffffff;
  text-align: center;
  width: 100%;
  margin: .4rem 0;
  line-height: .82rem;
}

.wrapper .header-layer {
  background-color: #F8F8F8;
  padding: 0.1rem 0.3rem;
}

.wrapper .header-layer .top-layer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}

.wrapper .header-layer .top-layer .txt {
  color: #333333;
  line-height: .75rem;
  flex: 1;
}

.wrapper .header-layer .top-layer .btn2 {
  width: 1.2rem;
  height: .5rem;
  background: rgba(255,238,226,1);
  border-radius: .1rem;
  font-size: .22rem;
  font-weight: 400;
  color: #E78F4E;
  line-height: .5rem;
  text-align: center;
}

.wrapper .header-layer .txt-layer {
  font-size: .24rem;
  color: #333333;
  line-height: .5rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 1rem;
}

.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 1.95rem;
  bottom: 0;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.content ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  // padding: 0 0.6rem
}

.item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
  position: relative;
}

.item > img {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  display: block;
}

.common-nodata-item {
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #333333;
  text-align: center;
}

.common-nodata-log {
  width: 4.16rem;
  height: 1.92rem;
  margin: .2rem auto;
  background: url('https://assets.rurushishi.com/yq-rs-make/t9/nodatapic.png') no-repeat center center;
  background-size: 4.16rem 1.92rem;
}

.data-item {
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #333333;
  padding-left: 0.28rem;
}

</style>